import { addDays, format } from 'date-fns';
export var DEFAULT_START_MONTH_INDEX = 0;
export var DEFAULT_MAX_MONTH_INDEX = 11;
var MAX_DATE_DISTANCE_IN_DAYS = 330;
var MAX_SELECT_RANGE_IN_DAYS = 32;
export var PRICELINE_DATE_FORMAT = 'yyyyMMdd';
var now = Date.now();
export var defaultToday = format(now, PRICELINE_DATE_FORMAT);
export var defaultMaxDate = format(addDays(now, MAX_DATE_DISTANCE_IN_DAYS), PRICELINE_DATE_FORMAT);
export var defaultMaxSelectableDate = format(addDays(now, MAX_SELECT_RANGE_IN_DAYS), PRICELINE_DATE_FORMAT);
//# sourceMappingURL=dates.js.map